import {getDiscoveryEventKey} from "./getDiscoveryPageViewMetadata";
import {registerDiscoveryPageEventKey} from "./registerDiscoveryPageEventKey";

type MixpanelPageViewClient = {
	register: (
		props: Record<string, string>,
		days_or_options?: number | {persistent?: boolean}
	) => void;
	track_pageview: (properties?: Record<string, string>) => void;
};

/**
 * Stamps the current route's `event_key` in-memory, then sends `$mp_web_page_view`
 * with that key. Must run only after Mixpanel init with autocapture pageview off,
 * or Mixpanel's own pageview would fire first with a stale key.
 */
export function trackDiscoveryMixpanelPageView(
	mixpanel: MixpanelPageViewClient | null,
	pathname: string
): void {
	if (!mixpanel) {
		return;
	}
	registerDiscoveryPageEventKey(mixpanel, pathname);
	mixpanel.track_pageview({event_key: getDiscoveryEventKey(pathname)});
}
